<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kupUf/tc-custom/9781250032713.jpg?1720280500352" alt="This image is the cover for the book Jane Eyre Laid Bare"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jane Eyre Laid Bare
      </h1>
      <p class="bookDescription body article font2">
        <p>Everyone is familiar with Charlotte Brontë's passionate, but restrained novel in which the plain, yet spirited governess Jane Eyre falls for the arrogant Mr. Rochester. It's a novel that simmers with sexual tension but never quite reaches the boiling point. Which is to be expected. After all, the original was written in 1847. That was then. This is now. And in JANE EYRE LAID BARE, author Eve Sinclair writes between the lines to chart the smoldering sexual chemistry between the long-suffering governess and her brooding employer. <br/><br/>When an eager and curious Jane Eyre arrives at Thornfield Hall her sexual desires are awakened. Who is the enigmatic Rochester and why is she attracted to him? What are the strange, yet captivating noises coming from the attic, and why does the very air she breathes feel heavy with passion? Only one thing is certain. Jane Eyre may have arrived at Thornfield an unfulfilled and tentative woman, but she will leave a very different person…<br/><br/>"An intriguing idea for a mashup." - <i>Kirkus Reviews</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charlotte Brontë, Eve Sinclair
      </h2>
      
      <p class="authorDescription body article">Charlotte Bront&euml; (1816&ndash;1855) was the eldest of the three Bront&euml; sisters who survived into adulthood. Raised in a strict Anglican home by her clergyman father after the deaths of her mother and two elder siblings, she published all of her poetry and fiction under the pen name Currer Bell. <I>Jane Eyre</I>, her most famous work, is widely considered one of the finest and most influential novels of the nineteenth century.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mactrade
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5dfb6bf1